export default __webpack_public_path__ + "static/media/mo.133e6da2.svg";